import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import DW from "../utils/images/LogoVoid.png";
import { useAuth } from "../AuthContext";
import MenuBurger from "../utils/icons/MenuBurger.svg";
import Facebook from "../utils/icons/Facebook.svg";
import Linkedin from "../utils/icons/Linkedin.svg";
import Instagram from "../utils/icons/Instagram.svg";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, logout, isLoading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/");
    setMobileOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: "Inicio" },
    { to: "/properties", label: "Propiedades" },
    { to: "/sale", label: "Venta" },
    { to: "/rent", label: "Alquileres" },
  ];

  return (
    <header className="absolute top-0 left-0 z-50 w-full font-dmSans shadow-md">
      <div className="bg-[#2a2a2a] text-gray-300 text-xs md:text-sm py-2 px-4 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto flex justify-between items-center relative">

          <div className="hidden lg:block w-[150px]"></div>

          <div className="flex-grow flex justify-start md:justify-center items-center space-x-4 md:space-x-6 lg:space-x-8">
            <span className="flex items-center whitespace-nowrap">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.042 11.042 0 005.115 5.115l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              <span className="sr-only">Teléfono: </span>+54 9 266 442-2515
            </span>
            <span className="hidden md:flex items-center whitespace-nowrap">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <span className="sr-only">Email: </span>secretariadwilliams@gmail.com
            </span>
            <span className="hidden lg:flex items-center whitespace-nowrap">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              <span className="sr-only">Dirección: </span>San Luis 5700, Argentina
            </span>
          </div>

          <div className="hidden lg:flex w-[150px] justify-end items-center space-x-3">
            <a href="https://maps.app.goo.gl/VE1n2SRGiTvpzenBA" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" title="Ubicación en Google Maps" aria-label="Ver nuestra ubicación en Google Maps">
              <svg aria-hidden="true" className="w-4 h-4 text-white opacity-80 hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/dwilliamsbr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Visitar nuestro perfil de Facebook">
              <img src={Facebook} alt="" aria-hidden="true" className="w-4 h-4 brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
            </a>
            <a href="https://www.instagram.com/dwilliamsbienesraices/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Visitar nuestro perfil de Instagram">
              <img src={Instagram} alt="" aria-hidden="true" className="w-4 h-4 brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
            </a>
            <a href="https://www.linkedin.com/company/86424565/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Visitar nuestro perfil de LinkedIn">
              <img src={Linkedin} alt="" aria-hidden="true" className="w-4 h-4 brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
            </a>
          </div>

          <div className="flex lg:hidden justify-end items-center space-x-3">
            <a href="https://maps.app.goo.gl/VE1n2SRGiTvpzenBA" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" title="Ubicación en Google Maps" aria-label="Ver nuestra ubicación en Google Maps">
              <svg aria-hidden="true" className="w-4 h-4 text-white opacity-80 hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/dwilliamsbr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Visitar nuestro perfil de Facebook">
              <img src={Facebook} alt="" aria-hidden="true" className="w-4 h-4 brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
            </a>
            <a href="https://www.instagram.com/dwilliamsbienesraices/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Visitar nuestro perfil de Instagram">
              <img src={Instagram} alt="" aria-hidden="true" className="w-4 h-4 brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
            </a>
            <a href="https://www.linkedin.com/company/86424565/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Visitar nuestro perfil de LinkedIn">
              <img src={Linkedin} alt="" aria-hidden="true" className="w-4 h-4 brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
            </a>
          </div>
        </div>
      </div>

      <nav ref={menuRef} className="relative bg-[#fcfcfd] px-4 py-3 md:px-12 lg:px-20 transition-all duration-300">
        <div className="max-w-7xl mx-auto flex items-center justify-between">

          <div className="flex flex-shrink-0 items-center md:w-[150px]">
            <Link to="/" aria-label="Volver al inicio">
              <img src={DW} alt="Logotipo DWilliams Bienes Raíces" className="h-10 w-auto object-contain" style={{ maxWidth: "60px" }} />
            </Link>
          </div>

          {/* ACÁ ESTÁ EL CAMBIO: text-xl y font-bold para escritorio */}
          <div className="hidden flex-1 items-center justify-center space-x-12 md:flex lg:space-x-20">
            {navLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className="text-xl font-bold text-gray-700 transition-colors hover:text-black"
              >
                {label}
              </Link>
            ))}
            {currentUser && !isLoading && (
              <Link
                to="/panelAdmin"
                className="text-xl font-bold text-gray-700 transition-colors hover:text-black"
              >
                Admin
              </Link>
            )}
          </div>

          <div className="hidden flex-shrink-0 items-center justify-end md:flex md:w-[150px]">
            {currentUser && (
              <button
                className="rounded-full bg-[#2a2a2a] px-7 py-3 text-sm font-semibold text-white shadow-sm transition-all hover:bg-black hover:shadow-md"
                onClick={handleLogout}
              >
                Cerrar sesión
              </button>
            )}
          </div>

          <button
            type="button"
            className="ml-auto inline-flex items-center rounded-lg p-2 md:hidden"
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label="Abrir menú"
          >
            <img className="h-8 w-8" src={MenuBurger} alt="Menú" />
          </button>
        </div>

        {mobileOpen && (
          <div className="absolute left-0 top-full w-full bg-[#fcfcfd] shadow-xl border-t border-gray-100 md:hidden">
            <div className="flex flex-col px-6 py-4">
              {/* ACÁ ESTÁ EL CAMBIO: text-lg y font-bold para mobile */}
              {navLinks.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  onClick={() => setMobileOpen(false)}
                  className="block py-3 text-lg font-bold text-gray-800 border-b border-gray-50 transition-colors hover:text-black"
                >
                  {label}
                </Link>
              ))}
              {currentUser && !isLoading && (
                <Link
                  to="/panelAdmin"
                  onClick={() => setMobileOpen(false)}
                  className="block py-3 text-lg font-bold text-gray-800 border-b border-gray-50 transition-colors hover:text-black"
                >
                  Admin
                </Link>
              )}

              {currentUser && (
                <div className="mt-4 pb-2">
                  <button
                    className="w-full rounded-full bg-[#2a2a2a] py-3 font-semibold text-white transition-colors hover:bg-black"
                    onClick={handleLogout}
                  >
                    Cerrar sesión
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Navbar;